import { render, staticRenderFns } from "./OperatorDashboard.vue?vue&type=template&id=20891b4c&"
import script from "./OperatorDashboard.vue?vue&type=script&lang=js&"
export * from "./OperatorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports